module.exports = __webpack_public_path__ + "static/media/vf_mtshirts_core.3236aeaf.svg";